import { transparentize } from 'polished';
import c from './colors';
import { setAlpha } from './utils';

// TODO: rename backgrounds, conflicts with polished exports

/**
 * @see http://livingston.sas.com/10-0/essentials/background/
 */
export const backgrounds = {
  page(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          bg: c.black(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bg: c.p_2(theme)
        };
      case 'high-contrast':
        return {
          bg: c.black(theme)
        };
      default:
        return {
          bg: c.n4(theme)
        };
    }
  },
  modal(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          bg: c.black(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'high-contrast':
        return {
          bg: c.black60(theme)
        };
      default:
        return {
          bg: transparentize(0.4, c.white(theme))
        };
    }
  },
  panes(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          bg: c.black(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bg: c.p_3(theme)
        };
      case 'high-contrast':
        return {
          bg: c.black(theme)
        };
      default:
        return {
          bg: c.white(theme)
        };
    }
  }
};

/**
 * @see http://livingston.sas.com/10-0/essentials/background/
 */
export const backgroundDepths = {
  standard(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          bg: c.black(theme),
          bd: c.white(theme),
          sh: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bg: c.p_3(theme),
          bd: transparentize(0.85, c.white(theme)),
          sh: 'none'
        };
      case 'high-contrast':
        return {
          bg: c.black(theme),
          bd: c.white(theme),
          sh: 'none'
        };
      default:
        return {
          bg: c.white(theme),
          bd: c.n3(theme),
          sh: 'none'
        };
    }
  },
  small(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          bg: c.black(theme),
          bd: c.white(theme),
          sh: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bg: c.p_3(theme),
          bd: 'transparent',
          sh: '0px 1px 8px 0px rgba(252,252,252,0.2)'
        };
      case 'high-contrast':
        return {
          bg: c.black(theme),
          bd: c.n2(theme),
          sh: '0px 1px 8px 0px rgba(0,0,0,1.0)'
        };
      default:
        return {
          bg: c.white(theme),
          bd: 'transparent',
          sh: '0px 1px 4px 0px rgba(0,0,0,0.2)'
        };
    }
  },
  medium(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          bg: c.black(theme),
          bd: c.white(theme),
          sh: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bg: c.p_2(theme),
          bd: 'transparent',
          sh: '0px 1px 16px 0px rgba(0,0,0,0.6)'
        };
      case 'high-contrast':
        return {
          bg: c.black(theme),
          bd: c.n2(theme),
          sh: '0px 1px 16px 0px rgba(0,0,0,1.0)'
        };
      default:
        return {
          bg: c.white(theme),
          bd: 'transparent',
          sh: '0px 1px 16px 0px rgba(0,0,0,0.2)'
        };
    }
  },
  large(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          bg: c.black(theme),
          bd: c.white(theme),
          sh: 'none'
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bg: c.p_3(theme),
          bd: 'transparent',
          sh: '0px 1px 32px 0px rgba(0,0,0,0.6)'
        };
      case 'high-contrast':
        return {
          bg: c.black(theme),
          bd: c.n2(theme),
          sh: '0px 1px 32px 0px rgba(0,0,0,1.0)'
        };
      default:
        return {
          bg: c.white(theme),
          bd: 'transparent',
          sh: '0px 1px 32px 0px rgba(0,0,0,0.2)'
        };
    }
  }
};

/**
 * Temporary doc until the new Design System site is up
 * @see https://gitlab.sas.com/novacommons/nova-tokens/-/tree/master/tokens
 */
export const backgroundDepthsNova = {
  standard(theme) {
    return {
      bg: c.colorUiLight(theme),
      bd: c.colorUiBorder(theme),
      sh: 'none'
    };
  },
  small(theme) {
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bg: c.colorUiDark(theme),
          bd: 'transparent',
          sh: '0px 1px 8px 0px rgba(0,0,0,0.8)'
        };
      case 'high-contrast':
        return {
          bg: c.colorUiLight(theme),
          bd: c.colorUiBorder(theme),
          sh: '0px 1px 8px 0px rgba(0,0,0,1.0)'
        };
      default:
        return {
          bg: c.colorUiLight(theme),
          bd: 'transparent',
          sh: '0px 1px 4px 0px rgba(0,0,0,0.2)'
        };
    }
  },
  medium(theme) {
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bg: c.colorUiLight(theme),
          bd: 'transparent',
          sh: '0px 1px 16px 0px rgba(0,0,0,0.6)'
        };
      case 'high-contrast':
        return {
          bg: c.colorUiLight(theme),
          bd: c.colorUiBorder(theme),
          sh: '0px 1px 16px 0px rgba(0,0,0,1.0)'
        };
      default:
        return {
          bg: c.colorUiLight(theme),
          bd: 'transparent',
          sh: '0px 1px 16px 0px rgba(0,0,0,0.2)'
        };
    }
  },
  large(theme) {
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bg: c.colorUiLight(theme),
          bd: 'transparent',
          sh: '0px 1px 32px 0px rgba(0,0,0,0.6)'
        };
      case 'high-contrast':
        return {
          bg: c.colorUiLight(theme),
          bd: c.colorUiBorder(theme),
          sh: '0px 1px 32px 0px rgba(0,0,0,1.0)'
        };
      default:
        return {
          bg: c.colorUiLight(theme),
          bd: 'transparent',
          sh: '0px 1px 32px 0px rgba(0,0,0,0.2)'
        };
    }
  }
};
export const backgroundsNova = {
  page(theme) {
    return {
      bg: c.colorUiDark(theme)
    };
  },
  modal(theme) {
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          bg: setAlpha(c.colorUiLight(theme), 0.4)
        };
      case 'high-contrast':
        return {
          bg: c.colorUiLight(theme)
        };
      default:
        return {
          bg: setAlpha(c.colorUiLight(theme), 0.4)
        };
    }
  },
  panes(theme) {
    return {
      bg: c.colorUiLight(theme)
    };
  }
};
//# sourceMappingURL=backgrounds.js.map